/**
 * API de Desbloqueio de Confiança específica para integração Hubsoft.
 * Envia: id (id_cliente_servico do contrato) e qtd_dias (obrigatório).
 */
import { axiosInstance } from '@/service/axios';

export async function requestDesbloqueioConfiancaHubsoft(idClienteServico: number, qtdDias: number): Promise<void> {
  await axiosInstance.get('/desbloqueio-confianca/', {
    params: { id: idClienteServico, qtd_dias: qtdDias },
  });
}
